import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../styles/Login.css";
import { useAuth } from "../AuthContext";  // ✅ useAuth 가져오기
import useMyIP from "./useMyIP"; // 훅 import
import AddLog from "./AddLog"; // ✅ 로그 저장 함수 가져오기
//import Logout from './Logout';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const Login = ({ setUserType, setUserData = () => { } }) => {
    const myIP = useMyIP(); // ✅ useState로 감싸지 않고 직접 호출
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const navigate = useNavigate();
    const { login } = useAuth();  // ✅ useAuth에서 login 함수 가져오기
    //const [shouldLogout, setShouldLogout] = useState(false); // 로그아웃 트리거 상태

    

    
    
    // shouldLogout 상태가 true면 Logout 컴포넌트를 렌더링
    //if (shouldLogout) {
    //    return <Logout />;
    //}

    // 컴포넌트가 마운트될 때 userType을 공백으로 설정
    useEffect(() => {
        //로그인 상태
        //sessionStorage.setItem("userType", "");
        
        login("");
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // setUserType이 변경될 때마다 실행

    

    const handleLogin = async () => {
        //console.log("setUserData 확인:", setUserData);  // 🔍 setUserData가 함수인지 확인

        //if (typeof setUserData !== "function") {
        //    console.error("❌ setUserData is not a function! 부모 컴포넌트에서 전달되지 않았을 가능성이 높습니다.");
        //    return;
        //}
        //console.log("내IP:", myIP);
        
        try {
            
            const response = await axios.post(`${API_BASE_URL}/api/account/login`, {
                userId,
                password
            });
            //alert(password);

            const user = response.data;   
            login(user);  // ✅ user 상태 업데이트
            //console.log("서버에서 받은 사용자 데이터:", user); // ✅ 데이터 확인

            if (!user || typeof user !== "object") {
                throw new Error("user 데이터가 유효하지 않습니다.");
            }

            

            setUserType(user.userType);  // 회원 구분 저장   
            //alert(user.userType);

            setUserData(user);  // 전체 사용자 정보 저장
            login(user);  // ✅ 여기에서 user 상태 업데이트!

            // 로그인 처리 후
            //로그인 상태
            sessionStorage.setItem("userType", user.userType);
            // 필요시 user 정보도 저장
            //localStorage.setItem("user", JSON.stringify(user));


            //alert("1");

            // 페이지 이동
            //console.log(user.userType);
            if (user.userType === "") {
                navigate("/login");                                
            } else if (user.userType === "G") {
                await AddLog(user.userId, myIP, "", "1-2");
                navigate("/tombsmap");
            } else {
                await AddLog(user.userId, myIP, "", "1-2");
                navigate("/enshrine");
            }
            

            //password = user.userPW;
        } catch (error) {
            //console.error("로그인 오류:", error);
            //alert(error.response?.data?.message || error);            
            if (error.response) {
                // 서버 응답 오류
                //console.error("Server Response Error: ", error.response);

                await AddLog(userId, myIP, "", "1-1");

                alert(error.response.data?.message || "서버 오류");
            } else if (error.request) {
                // 요청은 갔으나 응답이 없을 경우
                //console.error("No Response: ", error.request);
                alert("서버에 응답이 없습니다.");
            } else {
                // 요청 설정 오류
                //console.error("Error Message: ", error.message);
                alert("로그인 요청 오류 발생");
            }
        }
    };

   

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>로그인</h2>
                <input
                    type="text"
                    placeholder="사용자 ID"
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            document.getElementById("passwordInput").focus(); // 패스워드 입력창으로 이동
                        }
                    }}
                />
                <input
                    id="passwordInput"
                    type="password"
                    placeholder="비밀번호"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handleLogin(); // 로그인 실행
                        }
                    }}
                />
                <button onClick={handleLogin}>로그인</button>
            </div>
        </div>
    );
};

export default Login;

